import React from 'react';

import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {FooterModuleMobile} from "./mobile/footer-module.mobile";
import {FooterModuleDesktop} from "./desktop/footer-module.desktop";
import {FooterModuleController} from "../footer-module.controller";
import {FooterModuleLinkModel} from "../models/footer-module.link-model";
import {FOOTER_MODULE} from "../footer-module.consts";
import styles from "../styles/footer.module.scss";
import classNames from "classnames";
import {THEME} from "../../../../../core/app/consts";

export class FooterModuleComponentProps extends BaseModuleProps {}

export const FooterModuleComponent = ({controller}) => {
  const {state, device} = controller;
  const {isBolao, currentLinkModel} = state;
  const {isLargeView} = device;

  const footerProps = {
    controller,
    onItemClick: (link: FooterModuleLinkModel) => controller.action(FOOTER_MODULE.ACTION_TYPES.itemClickEvent, {
      itemType: link.itemType,
      currentLinkModelName: currentLinkModel.name
    })
  }

  return (
    <footer data-theme={THEME.DARK} className={classNames(styles.container, {[styles.small_view]: !isLargeView}, {[styles.bolao] : isBolao})}>
      {
        !isLargeView ? <FooterModuleMobile {...footerProps} /> : <FooterModuleDesktop {...footerProps} />
      }
    </footer>
  );
}

const settings: ComposeSettings = {
  component: FooterModuleComponent,
  propsType: FooterModuleComponentProps,
  controllerType: FooterModuleController,
  createModule: true,
  observe: true,
}

export default Compose(settings);
